module.exports = __webpack_public_path__ + "img/vid03.89dfe02e.jpg";